<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.userNum')}}</span>
        </div>
        <input class="e-input" :value='userNum' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox" style="height: 420px">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.add")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='addBlack'>
                  <span class="e-btn-icon icon hero-icon hero-icon-save e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='30' textAlign='Center'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' headerText='MC-ID' width='150' textAlign='Center'></e-column>
            <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div>
      <ejs-pager @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import commonJS from '../../common';
import DialogList from '../../../util/tipDialog/DialogList';
import CustomDialog from '../../../../common/CustomDialog';

export default {
  name: 'AddBlackDialog',
  props: [
    'neid'
  ],
  components: {
    DialogList,
    CustomDialog
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      userNum: '',
      mcsid: '',
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      vo: {
        flag: '',
        participantType: ''
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.confirm') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {
    getGridData(mcsid = this.mcsid, userNum = this.userNum) {
      const $this = this;
      this.userNum = userNum;
      this.mcsid = mcsid;
      const vo = {
        flag: 0,
        participantType: 0
      };
      const page = {
        pageNo: 1,
        pageSize: this.page.pageSize
      };
      const params = {
        info: {
          neid: $this.neid,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: 1,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.countrsp;
      });
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    getGridMCID() {
      const gridData = this.$refs.grid.getSelectedRecords();
      if (gridData.length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'))
        return null;
      };
      const mcsid = [];
      gridData.forEach((item) => {
        mcsid.push(item.mcsid);
      });
      return mcsid;
    },

    getGridMCName() {
      const gridData = this.$refs.grid.getSelectedRecords();
      if (gridData.length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return null;
      };
      const userNum = [];
      gridData.forEach((item) => {
        userNum.push(item.userNum);
      });
      return userNum;
    },

    addBlack() {
      const $this = this;
      const mcid = this.getGridMCName();
      if (mcid === null) return;
      const userNum = [];
      this.$refs.grid.getSelectedRecords().forEach((item) => {
        userNum.push(item.userNum);
      });
      const logArray = [];
      userNum.forEach((numItem) => {
        logArray.push({
          userNum: $this.userNum,
          blackNum: numItem
        })
      });
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.addBlackList,
          operation: 'bacthOperate'
        },
        vo: {
          0: {
            vo: this.voCycleSpell(new Map().set('mcsid', this.mcsid), new Map().set('blackNum', mcid), mcid.length),
            info: {
              neid: this.neid,
              msgid: this.msg.addBlackList,
              operation: 'bacthOperate',
              mcsFlag: true
            },
          }
        },
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.mcsAddBlack',
          exectype: 1,
          execData: logArray
        }
      };
      const opCount = userNum.length;
      const resObj = [];
      for (let i = 0; i < opCount; i++) {
        const resData = {};
        resData.operObj = userNum[i];
        resObj.push(resData);
      }
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        resObj.forEach((item, index) => {
          item.operResult = response.data.resultVal[index].display;
          item.operCode = response.data.resultVal[index].code;
        });
        this.$refs.dialog.addOperetionResultList(resObj);
        this.$refs.dialog.setTotalCount(opCount);
        this.$refs.dialogPage.show();
      });
    },
  },
};
</script>

<style scoped>

</style>
